<template>
  <div>
    <!-- Start: Content -->
    <section class="reservation-info" v-if="!isLoading">
      <div class="container">
        <div class="row">
          <div class="col-sm-7">
            <div class="header--reservation-detail">
              <div class="header--reservation-box">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb mb-35 pz">
                    <li class="breadcrumb-item">
                      <router-link
                        :to="fromTenant ? '/job/tenant' : '/job/provider'"
                      >
                        Manage Reservation
                      </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Reservation Logging
                    </li>
                  </ol>
                </nav>
                <h4>Reservation Details</h4>
                <div class="table-legend">
                  <ul>
                    <li v-if="isAirportTransfer && isArrivedFlight">
                      <i class="ic-flight-icon"></i>Airport Transfer
                    </li>
                    <li v-if="isAirportTransfer && isDepartureFlight">
                      <i class="ic-flight-departure-icon"></i>Airport Transfer
                    </li>
                    <li
                      style="display: flex; justify-content: center"
                      v-else-if="
                        isAirportTransfer &&
                        !isArrivedFlight &&
                        !isDepartureFlight
                      "
                    >
                      <i class="ic-car-alt">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 1200 1200"
                        >
                          <path
                            fill="currentColor"
                            d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                          />
                        </svg>
                      </i>
                      Point to Point
                    </li>
                    <li v-else-if="!isAirportTransfer">
                      <i class="ic-time"></i>Hourly Booking
                    </li>
                  </ul>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Code</div>
                <div class="label-title">
                  <span>{{ reservation.reservationCode }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Date</div>
                <div class="label-title">
                  <span>
                    {{
                      $helper.dateFormatted(
                        reservation.reservationDateTime.dateTime
                      )
                    }}
                  </span>
                </div>
              </div>
              <div class="label-group" v-if="driver && driver.fullName">
                <div class="label">Driver Name</div>
                <div class="label-title">
                  <span>
                    {{ driver.title ? `${driver.title}.` : "" }}
                    {{ driver.fullName }}</span
                  >
                </div>
              </div>
              <div class="label-group" v-if="vehicle && vehicle.plateNumber">
                <div class="label">Vehicle Number</div>
                <div class="label-title">
                  <span> {{ vehicle.plateNumber }} </span>
                </div>
              </div>
            </div>
            <div class="body--reservation-detail">
              <div class="row">
                <div class="col-sm-6">
                  <i class="ic-businessmen --green pull-left mr-10"></i>
                  <h4 class="--green">Passenger Details</h4>
                  <div class="label-group">
                    <div class="label">Name</div>
                    <div class="label-title">
                      {{ reservation.passenger.title }}.
                      {{ reservation.passenger.fullName }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Phone</div>
                    <div class="label-title">
                      {{
                        reservation.passenger.phoneCode &&
                        reservation.passenger.phoneNumber
                          ? `(+${reservation.passenger.phoneCode}) ${reservation.passenger.phoneNumber}`
                          : "N/A"
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 divider-left text-right">
                  <h4>Booker</h4>
                  <div class="label-group">
                    <div class="label">Name</div>
                    <div class="label-title">
                      {{ reservation.booker.title }}.
                      {{ reservation.booker.fullName }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Phone</div>
                    <div class="label-title">
                      {{
                        reservation.booker.phoneCode &&
                        reservation.booker.phoneNumber
                          ? `(+${reservation.booker.phoneCode}) ${reservation.booker.phoneNumber}`
                          : "N/A"
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="passenger-flight-info">
              <div v-if="reservation.noteToDriver">
                <h4 style="margin-top: 15px">Notes to Driver</h4>
                <div class="passenger-notes">
                  {{ reservation.noteToDriver }}
                </div>
              </div>
            </div>
            <div class="box-addons mt-20">
              <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                  <div class="panel-heading text-center">
                    <h4 class="panel-title">
                      <a
                        data-toggle="collapse"
                        data-parent="#accordion"
                        href="#collapse1"
                        class="--green"
                      >
                        <i class="ic-History mr-10"></i>Reservation Logging
                      </a>
                    </h4>
                    <!-- <button class="btn btn-primary" @click="handleCreateLog()">
                      Create
                    </button> -->
                  </div>
                  <div id="collapse1" class="panel-collapse collapse in">
                    <div class="panel-body">
                      <div class="trip-info">
                        <div
                          v-for="(log, index) in reservation.tripLogs"
                          :key="index"
                        >
                          <div class="col-sm-3">
                            <div class="time__depart">
                              <div class="time_Is">
                                {{
                                  $helper.timeFormattedFull(
                                    log.timeStamp.dateTime
                                  )
                                }}
                              </div>
                              <div class="date_Is">
                                ({{ log.timeStamp.timezone }})
                              </div>
                              <div class="date_Is">
                                {{
                                  $helper.dateFormatted(log.timeStamp.dateTime)
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-9">
                            <div
                              :class="[
                                index === reservation.tripLogs.length - 1
                                  ? 'end-time-stamp'
                                  : 'time-stamp',
                                log.event.toLowerCase().includes('dropped')
                                  ? 'dropped'
                                  : '',
                              ]"
                            >
                              <div
                                class="stamp-status d-flex items-center --green"
                              >
                                <span>{{ log.event }}</span>
                                <button
                                  class="ml-5 btn-edit-alt"
                                  @click="
                                    handleEditLog(
                                      log,
                                      reservation.pickUpDateTime
                                    )
                                  "
                                  v-if="
                                    showEditable(log.event) &&
                                    userType === 'TenantUser'
                                  "
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    viewBox="0 0 24 24"
                                  >
                                    <g
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    >
                                      <path
                                        d="M9 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-3"
                                      ></path>
                                      <path
                                        d="M9 15h3l8.5-8.5a1.5 1.5 0 0 0-3-3L9 12v3"
                                      ></path>
                                      <path d="M16 5l3 3"></path>
                                    </g>
                                  </svg>
                                </button>
                              </div>
                              <div class="stamp-desc">
                                {{ "User : " + log.createdBy }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-5">
            <div class="reservation-summary--small">
              <div
                class="route-card mb-30 bb-1"
                :class="{
                  'grid-cols-1fr': dropOffLocation === 'Same Location',
                }"
              >
                <!-- Pick-up -->
                <div class="route-column pickup">
                  <div
                    class="name-location"
                    :title="pickUpLocation"
                    :class="{ rental: !isAirportTransfer }"
                  >
                    {{ pickUpLocation }}
                  </div>
                  <div class="address-location">
                    {{ pickUpLocationAddress }}
                  </div>
                  <a
                    href="javascript:void(0)"
                    @click="
                      onClickOpenDetailLocation(reservation.pickUpLocation)
                    "
                    class="link-location --green"
                    >View pick-up point</a
                  >

                  <div class="datetime">
                    <div class="rent-date">
                      <i class="ic-date-picker"></i>
                      {{
                        $helper.dateFormatted(
                          reservation.pickUpDateTime.dateTime
                        )
                      }}
                    </div>
                    <div class="rent-time">
                      <i class="ic-time"></i>
                      {{
                        $helper.timeFormatted(
                          reservation.pickUpDateTime.dateTime
                        )
                      }}
                      <span class="utc-zone"
                        >({{ reservation.pickUpDateTime.timezone }})</span
                      >
                    </div>
                    <div
                      class="rent-time"
                      v-if="reservation.serviceType.toLowerCase() === 'rental'"
                    >
                      <i class="ic-time"></i>
                      <span class="utc-zone"
                        >{{ getHours.hours }}
                        {{ getHours.hours > 1 ? "Hours" : "Hour" }}</span
                      >
                    </div>
                  </div>
                </div>

                <!-- Drop-off -->
                <div
                  class="route-column dropoff"
                  v-if="dropOffLocation !== 'Same Location'"
                >
                  <div class="name-location" :title="dropOffLocation">
                    {{ dropOffLocation }}
                  </div>
                  <div class="address-location">
                    {{ dropOffLocationAddress }}
                  </div>
                  <a
                    href="javascript:void(0)"
                    @click="
                      onClickOpenDetailLocation(reservation.dropOffLocation)
                    "
                    class="link-location --green"
                    >View drop-off point</a
                  >

                  <div class="datetime">
                    <div class="rent-date">
                      {{
                        $helper.dateFormatted(
                          reservation.dropOffDateTime.dateTime
                        )
                      }}
                      <i class="ic-date-picker" style="margin-left: 4px"></i>
                    </div>
                    <div class="rent-time">
                      {{
                        $helper.timeFormatted(
                          reservation.dropOffDateTime.dateTime
                        )
                      }}
                      <span class="utc-zone"
                        >({{ reservation.dropOffDateTime.timezone }})</span
                      >
                      <i class="ic-time" style="margin-left: 4px"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cRow">
                <template>
                  <div class="col-sm-12">
                    <img
                      :src="
                        (reservation.vehicle && reservation.vehicle.imageUri) ||
                        vehicle.imageUri
                      "
                      class="cars-image"
                      alt
                    />
                  </div>
                </template>
              </div>

              <div class="type-car">{{ reservation.vehicle.className }}</div>
              <div class="cars-brand">
                {{ reservation.vehicle.factoryName }}
                {{ reservation.vehicle.brandName }}
                {{
                  reservation.vehicle.plateNumber
                    ? `(${reservation.vehicle.plateNumber})`
                    : ""
                }}
                <span class="cars-brand-equivalent">or equivalent</span>
              </div>
              <div
                class="row"
                v-if="
                  hasPaxCapacity ||
                  hasLargeBaggageCapacity ||
                  hasSmallBaggageCapacity
                "
              >
                <div class="col-sm-7">
                  <div class="capacity-seat" v-if="hasPaxCapacity">
                    Pax Capacity {{ reservation.vehicle.feature.paxCapacity }}
                  </div>
                  <div
                    class="capacity-large-baggage"
                    v-if="hasLargeBaggageCapacity"
                  >
                    Large Bag. Capacity x{{
                      reservation.vehicle.feature.largeBaggageCapacity
                    }}
                  </div>
                  <div class="capacity-baggage" v-if="hasSmallBaggageCapacity">
                    Small Bag. Capacity x{{
                      reservation.vehicle.feature.smallBaggageCapacity
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div
              class="admin-section-wrapper mt-20"
              v-if="isAllowViewAdminNotes && adminNotes"
            >
              <div class="row">
                <div class="col-sm-12">
                  <h4>Admin – For internal use only</h4>
                  <table class="table-admin-notes">
                    <tr v-if="adminNotes">
                      <td class="label">Admin Notes</td>
                      <td class="colon-label">:</td>
                      <td class="label-value">{{ adminNotes }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <!-- .reservation-summary--small -->

            <div
              class="button-wrapper-log"
              v-if="showButtonNext || (showButtonCompleteTrip && !progressDone)"
            >
              <button
                class="btn btn-complete-trip"
                v-if="showButtonCompleteTrip && !progressDone"
                @click="openCompleteTrip()"
              >
                <span>Complete Trip</span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248s248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200c0 110.532-89.451 200-200 200c-110.532 0-200-89.451-200-200c0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                    fill="currentColor"
                  ></path>
                </svg>
              </button>
              <button
                class="btn btn-next"
                @click="nextState()"
                v-if="showButtonNext"
                style="
                  text-wrap: wrap;
                  white-space: normal;
                  word-break: break-word;
                "
              >
                <span>{{ reservation.workflow.next.description }}</span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 32 32"
                >
                  <defs></defs>
                  <path
                    d="M2 16A14 14 0 1 0 16 2A14 14 0 0 0 2 16zm6-1h12.15l-5.58-5.607L16 8l8 8l-8 8l-1.43-1.427L20.15 17H8z"
                    fill="currentColor"
                  ></path>
                </svg>
              </button>
              <button
                class="btn btn-no-show mt-10"
                v-if="reservation.workflow.next.event === 14"
                @click="openModalPaxNoShow()"
                style="
                  text-wrap: wrap;
                  white-space: normal;
                  word-break: break-word;
                "
              >
                <span>Passenger No Show / Cancelled</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Content -->

    <div class="modal fade" role="dialog" ref="mapmodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-header" style="padding-bottom: 10px">
          <div class="pull-right">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <i class="ic-close"></i>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <mapModal />
          </div>
        </div>
      </div>
    </div>
    <!-- End: Modal -->

    <FormLogging @submit="onSubmitLogging" />
    <FormEditLogging @submit="onSubmitEditLogging" />
    <CompleteTripLog @finish="onSubmitCompleteTrip" />
    <PaxNoShow @confirm="confirmPaxNoShow" />

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import _ from "lodash";
import mapModal from "@/components/shared/MapModal";
import maverickMap from "@/plugins/google/map.js";
import tripLogJobService from "@/services/job/tripLogJob/tripLogJobService.js";
import inquiryTenantJobService from "@/services/job/tenantJob/inquiryTenantJobService.js";
import lookupService from "@/services/shop/lookup/lookupService.js";
import FormLogging from "@/components/shared/FormLogging";
import PaxNoShow from "@/components/shared/PaxNoShow";
import FormEditLogging from "@/components/shared/FormEditLogging";
import CompleteTripLog from "@/components/shared/CompleteTripLog";
import moment from "moment";
import { toHoursAndMinutes } from "@/helpers/numberHelper.js";
import { firebaseDB } from "@/plugins/firebase.js";
import { allowToViewAdminNotes } from "@/helpers/userHelper.js";

export default {
  components: {
    mapModal,
    FormLogging,
    FormEditLogging,
    CompleteTripLog,
    PaxNoShow,
  },
  data() {
    return {
      isLoading: false,
      msg: "Please wait",
      adminNotes: null,
      moneyFormat: null,
      additionalNotes: null,
      map: null,
      userType: "Unspecified",
      allServices: null,
      isDifferentCurrency: false,
      reservation: {
        vehicle: {
          imageUri: "",
        },
      },
      eventData: [],
      supportedCurrency: [],
      waitingTimeData: null,
      driver: null,
      vehicle: null,
      durationInMinutes: 0,
    };
  },
  computed: {
    isAllowViewAdminNotes: function () {
      return allowToViewAdminNotes(this.allServices);
    },
    getHours: function () {
      const minutes = this.durationInMinutes ? this.durationInMinutes : 0;
      return toHoursAndMinutes(minutes);
    },
    pickUpLocation: function () {
      return this.reservation &&
        this.reservation.pickUpLocation &&
        this.reservation.pickUpLocation.name
        ? this.reservation.pickUpLocation.name
        : "";
    },
    pickUpLocationAddress: function () {
      return this.reservation &&
        this.reservation.pickUpLocation &&
        this.reservation.pickUpLocation.address
        ? this.reservation.pickUpLocation.address
        : "";
    },
    dropOffLocation: function () {
      return this.reservation &&
        this.reservation.dropOffLocation &&
        this.reservation.dropOffLocation.name &&
        this.reservation.dropOffLocation.name !== this.pickUpLocation
        ? this.reservation.dropOffLocation.name
        : "Same Location";
    },
    dropOffLocationAddress: function () {
      return this.reservation &&
        this.reservation.dropOffLocation &&
        this.reservation.dropOffLocation.name &&
        this.reservation.dropOffLocation.name !== this.pickUpLocation
        ? this.reservation.dropOffLocation.address
        : "Same Location";
    },
    isAirportTransfer: function () {
      return (
        this.reservation &&
        this.reservation.serviceType &&
        this.reservation.serviceType === "AirportTransfer"
      );
    },
    isArrivedFlight: function () {
      return (
        this.reservation &&
        this.reservation.pickUpLocation &&
        this.reservation.pickUpLocation.isAirportZone
      );
    },
    isDepartureFlight: function () {
      return (
        this.reservation &&
        this.reservation.dropOffLocation &&
        this.reservation.dropOffLocation.isAirportZone
      );
    },
    hasPaxCapacity: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.paxCapacity &&
        parseInt(this.reservation.vehicle.feature.paxCapacity) > 0
      );
    },
    hasLargeBaggageCapacity: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.largeBaggageCapacity &&
        parseInt(this.reservation.vehicle.feature.largeBaggageCapacity) > 0
      );
    },
    hasSmallBaggageCapacity: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.smallBaggageCapacity &&
        parseInt(this.reservation.vehicle.feature.smallBaggageCapacity) > 0
      );
    },
    showButtonNext: function () {
      return (
        this.reservation.workflow &&
        this.reservation.workflow.next &&
        this.reservation.workflow.next.event !== 0
      );
    },
    showButtonCompleteTrip: function () {
      return (
        this.reservation.workflow.next &&
        this.reservation.workflow.current.event === 18
      );
    },
    progressDone: function () {
      return this.reservation.jobStatusDescription === "Done";
    },
    fromTenant: function () {
      return this.$route.path.includes("tenant");
    },
  },
  async created() {
    this.$helper.scrollTop();
    await this.reservationLogging();
    const { userType, services } = await this.$store.dispatch(
      "user/getProfile"
    );
    this.userType = userType;
    this.allServices = services;
    await this.getEventAvailable();
    await this.getDetailReservation();

    if (!this.progressDone) {
      this.getAvailableCurrency();
    }
  },
  beforeDestroy() {
    this.$store.state.setting.transactionCurrency = null;
  },
  mounted() {
    if (!this.map) {
      // creates map instance
      this.map = new maverickMap({
        mapId: "map",
        lat: -6.17003832454938,
        lng: 106.81490242481232,
        infoWindow: true,
      });
      this.map.initialize();
    }
  },
  methods: {
    async getAvailableCurrency() {
      const response = await inquiryTenantJobService.getAvailableCurrency(
        this.$route.params.id
      );

      if (response.isSuccess) {
        this.supportedCurrency = response.data;
      }
    },
    async getDetailReservation() {
      try {
        const reservation = await inquiryTenantJobService.getDetail(
          this.$route.params.id
        );
        this.adminNotes = reservation.adminNotes;
        this.moneyFormat = reservation.moneyFormat;
        this.driver = reservation.driver;
        this.vehicle = reservation.vehicle;
        this.durationInMinutes = reservation.durationInMinutes;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async reservationLogging() {
      this.isLoading = true;
      try {
        const response = await tripLogJobService.getTripLogging(
          this.$route.params.id
        );

        if (response.isSuccess) {
          this.reservation = response.data;
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getEventAvailable() {
      try {
        const response = await lookupService.availableEvent();
        const data = response.data;
        const dataArray = [];

        for (const key in data) {
          dataArray.push({ value: parseInt(key), label: data[key] });
        }

        this.eventData = dataArray;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    handleCreateLog() {
      this.$eventBus.$emit("FormLogging", this.eventData);
    },
    handleEditLog(data, pickUpDateTime) {
      this.$eventBus.$emit(
        "FormEditLogging",
        data,
        pickUpDateTime,
        this.userType
      );
    },
    nextState() {
      const numberUtc = this.reservation.pickUpDateTime.timezone.replace(
        "UTC",
        ""
      );

      const date = moment().utcOffset(`${numberUtc}`);

      const payload = {
        event: this.reservation.workflow.next.event,
        date: date.format("YYYY-M-D"),
        time: date.format("H:m:s"),
        description: null,
      };

      this.onSubmitLogging(payload);
    },
    async onSubmitLogging(data) {
      this.isLoading = true;
      try {
        // const dateSplit = data.date.split("-");
        // const timeSplit = data.time.split(":");
        const payload = {
          event: data.event,
          // timestamp: {
          //   year: Number(dateSplit[0]),
          //   month: Number(dateSplit[1]),
          //   day: Number(dateSplit[2]),
          //   hour: Number(timeSplit[0]),
          //   minute: Number(timeSplit[1]),
          //   second: Number(timeSplit[2]),
          // },
          description: data.description,
        };
        const response = await tripLogJobService.createTripLog(
          this.$route.params.id,
          payload
        );
        if (response.isSuccess) {
          if (response.data) {
            this.waitingTimeData = {
              arrivalWaitingTime: response.data.arrivalWaitingTime,
              allowedTime: response.data.allowedTime,
            };
            this.openCompleteTrip();
            return;
          }
          this.$notification.success("Successfully added new trip log.", {
            title: "Success",
          });
          this.getEventAvailable();
          await this.reservationLogging();
          this.updateReservationOnFirebase(this.reservation.reservationId, {
            lastStateEnum: this.reservation.workflow.current.event,
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    updateReservationOnFirebase(reservationId, data) {
      firebaseDB
        .ref("locations/" + reservationId)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            firebaseDB.ref("locations/" + reservationId).update(data);
          }
        });
    },
    deleteReservationOnFirebase(reservationId) {
      firebaseDB.ref("locations/" + reservationId).remove();
    },
    async onSubmitEditLogging(data) {
      this.isLoading = true;
      try {
        const numberUtc = this.reservation.pickUpDateTime.timezone.replace(
          "UTC",
          ""
        );
        const date = moment().utcOffset(`${numberUtc}`);
        const dateSplit = data.date.split("-");
        const timeSplit = data.time.split(":");

        const payload = {
          timestamp: {
            year: Number(dateSplit[0]),
            month: Number(dateSplit[1]),
            day: Number(dateSplit[2]),
            hour: Number(timeSplit[0]),
            minute: Number(timeSplit[1]),
            second: date.second(),
          },
          description: data.description,
        };

        const response = await tripLogJobService.updateTripLog(
          this.$route.params.id,
          data.id,
          payload
        );

        if (response.isSuccess) {
          this.$notification.success("Successfully updated trip log.", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
        this.isLoading = false;
      } finally {
        this.reservationLogging();
        this.getEventAvailable();
      }
    },
    onClickOpenDetailLocation(detail) {
      this.map.showInfoWindow(
        {
          latitude: detail.latitude,
          longitude: detail.longitude,
        },
        detail.address
      );
      $(this.$refs.mapmodal).modal();
    },
    async openCompleteTrip() {
      this.isLoading = true;

      this.$eventBus.$emit(
        "completeTripLog",
        this.reservation,
        this.supportedCurrency,
        this.moneyFormat,
        this.waitingTimeData
      );

      this.isLoading = false;
    },
    async onSubmitCompleteTrip(payload) {
      this.isLoading = true;
      try {
        const response = await tripLogJobService.completeTrip(
          this.$route.params.id,
          payload
        );

        if (response.isSuccess) {
          this.$notification.success("Job succesfully marked as completed.", {
            title: "Success",
          });
          this.deleteReservationOnFirebase(this.reservation.reservationId);
        }
      } catch (error) {
        for (let index = 0; index < error.errors.length; index++) {
          this.$notification.error(error.errors[index], { title: "Error" });
        }
      } finally {
        this.reservationLogging();
        this.isLoading = false;
      }
    },
    showEditable: function (value) {
      return (
        value === "Driver enroute to pick-up location" ||
        value === "Driver on site" ||
        value === "Passenger onboard" ||
        value === "Trip started" ||
        value === "Passenger dropped off" ||
        value === "Passenger no show / cancelled" ||
        value === "Driver enroute"
      );
    },
    openModalPaxNoShow() {
      const data = {
        uuid: this.uuidv4(),
        reservationId: this.$route.params.id,
      };
      this.$eventBus.$emit("PaxNoShow", data);
    },
    async confirmPaxNoShow(payload) {
      this.isLoading = true;
      try {
        const response = await tripLogJobService.confirmPaxNoShow(
          this.$route.params.id,
          payload
        );

        if (response.isSuccess) {
          this.waitingTimeData = response.data
            ? {
                arrivalWaitingTime: response.data.waitingTime,
                allowedTime: response.data.totalMinuteAllowed,
              }
            : null;
        }

        this.openCompleteTrip();
      } catch (error) {
        for (let index = 0; index < error.errors.length; index++) {
          this.$notification.error(error.errors[index], { title: "Error" });
        }
      } finally {
        this.isLoading = false;
      }
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
  },
  watch: {
    reservation: {
      deep: true,
      handler: function (value) {
        if (value.workflow.next === null) {
          this.deleteReservationOnFirebase(this.reservation.reservationId);
        }
      },
    },
  },
};
</script>

<style scoped>
.indicator-repriced {
  color: #d3d300;
  font-size: 20px;
  font-weight: 700;
  top: -10px;
}
.vue-stars label {
  font-size: 25px;
}

.payment-method:hover,
.other-action:hover {
  cursor: pointer;
}

.payment-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 5px 20px;
  border-top: 1px solid #ddd;
  margin-top: 13px;
}

.payment-wrapper div.dropdown {
  width: 80%;
}

.payment-wrapper div.dropdown-submitted {
  width: 80%;
}

.payment-wrapper div.dropdown.more-dropdown {
  width: 13%;
}

.payment-wrapper button.btn-primary,
.payment-wrapper button.btn-default {
  width: 100%;
  height: 42px;
  text-transform: uppercase;
  font-weight: 900;
  -webkit-box-shadow: 0px 4px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 4px 8px -5px #4c4c4c;
  box-shadow: 0px 4px 8px -5px #4c4c4c;
}

.payment-wrapper button.btn-paymentsubmit {
  width: 100%;
  height: 42px;
  text-transform: uppercase;
  background: #4fb848;
  font-weight: 900;
  -webkit-box-shadow: 0px 4px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 4px 8px -5px #4c4c4c;
  box-shadow: 0px 4px 8px -5px #4c4c4c;
  cursor: auto;
}

.payment-wrapper button.btn-aborted {
  width: 100%;
  height: 42px;
  text-transform: uppercase;
  background: #eb0011;
  font-weight: 900;
  -webkit-box-shadow: 0px 4px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 4px 8px -5px #4c4c4c;
  box-shadow: 0px 4px 8px -5px #4c4c4c;
  cursor: auto;
}

.payment-wrapper button.btn-default {
  background: rgb(234, 234, 234);
}

.info-wrapper {
  margin-top: 20px;
  font-size: 0.9333rem;
}

.dropdown-menu > li a a {
  color: #666 !important;
}

.stamp-status button {
  background: transparent;
  border: none;
  border-radius: 5px;
  color: #009688 !important;
}

.stamp-status button svg {
  width: 18px;
}

.panel-body .trip-button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 100%;
  margin-top: 10px;
}

.btn-back-log {
  color: #4fb848;
  background: #fff;
  width: 50%;
  border: 1px solid #4fb848;
}

.btn-next,
.btn-complete-trip,
.btn-no-show {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  background: #4fb848;
  color: #fff;
  width: 100%;
  text-transform: uppercase;
  font-weight: 700;
}

.btn-no-show {
  background: #eb0011;
}

.btn-next svg,
.btn-complete-trip svg {
  width: 25px;
}

.button-wrapper-log {
  border: 1px solid #ddd;
  padding: 10px 20px;
  margin-top: 45px;
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/reservation/inquiry/ReservationLogging.vue